import { render, staticRenderFns } from "./detail_pickup.vue?vue&type=template&id=b4aaacba&scoped=true"
import script from "./detail_pickup.vue?vue&type=script&lang=js"
export * from "./detail_pickup.vue?vue&type=script&lang=js"
import style0 from "./detail_pickup.vue?vue&type=style&index=0&id=b4aaacba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4aaacba",
  null
  
)

export default component.exports